import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getArticlesTheme = createAsyncThunk('articles/getArticlesTheme',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/articles/theme');
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getArticlesTheme;
